// Third party resources.
import "reflect-metadata"
import "array-find-polyfill"
import "intersection-observer"
import "promise-polyfill/src/polyfill"
import "../common/remove-polyfill"
import "custom-event-polyfill"

// Pattern library resources.
import EditableHeading from '../../../../bower_components/pattern-library-v2/dist/ts/buildables/editable-heading'
import ShareOptions from '../../../../bower_components/pattern-library-v2/dist/ts/buildables/share-options'

// Internal resources.
import ListOptions from './list-options'
import ListEntrance from './list-entrance'
import Run from "../decorators/runner"
import EditList from "./editing"
import CreateNewList from '../common/create-new-list'
import Sharing from "./sharing"
import UpdateSubscription from './update-subscription'

export class Main {

    @Run({
        declarations: [
            EditableHeading,
            ListOptions,
            ListEntrance,
            EditList,
            CreateNewList,
            ShareOptions,
            Sharing,
            UpdateSubscription
        ],
        runners: ['init', 'initialiseEditableHeading']
    })
    public init(): void { }
}